import {AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, UntypedFormControl} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {BsDatepickerConfig, BsLocaleService} from 'ngx-bootstrap/datepicker';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ToastrService} from 'ngx-toastr';
import {firstValueFrom, lastValueFrom} from 'rxjs';
import {ModuloPermissoesService} from 'src/app/api/module/erp/services/area-logada/modulo-permissoes/modulo-permissoes.service';
import {
  DescricaoMetoPagamentoEnum,
  MetoPagamentoEnum,
} from 'src/app/api/module/erp/shared/enumerable/metodo-pagamento.enum';
import {Modulo} from 'src/app/api/module/erp/shared/enumerable/modulos';
import {PropostaExternaEnum} from 'src/app/api/module/erp/shared/enumerable/poposta-externa.enum';
import {SubModuloNome} from 'src/app/api/module/erp/shared/enumerable/submodulos';
import {GeoLocalizacaoService} from 'src/app/api/module/erp/shared/geo-localizacao/geo-localizacao.service';
import {AtualizacaoForcadaService} from 'src/app/api/module/erp/shared/services/atualizacao-forcada-service.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {TabNavigationService} from 'src/app/api/module/erp/shared/services/tab-navegation/tab-navegation.service';
import {PagamentopPropostaService} from 'src/app/api/module/externo/services/proposta/pagamento.proposta.service';
import {ScrollService} from 'src/app/components/helper/service/scroll/scroll.service';

@Component({
  selector: 'app-proposta-pagamento-colaborador',
  templateUrl: './proposta-pagamento-colaborador.component.html',
  styleUrls: ['./proposta-pagamento-colaborador.component.scss'],
})
export class PropostaPagamentoColaboradorComponent implements OnInit, AfterViewInit {
  @ViewChild('modalVisualizarComprovanteBancario') modalVisualizarComprovanteBancario: any;
  modalVisualizarComprovanteBancarioRef?: BsModalRef;
  @Input() dadosBeneficiario!: any;

  @Input() somenteLeituraStep: boolean = false;
  caracteresDigitados: number = 0;
  mostrarCampo: boolean = false;
  formTitular!: FormGroup;
  listaCidades!: any;
  listaEstados!: any;
  listaPagamentos = new Array<any>();
  listaPagamentoCorretor = new Array<any>();
  listaPagamentosOriginal: any[] = []; // Cópia da lista original
  estadoInfo!: {name: string; uf: string} | null;
  modalRef!: BsModalRef;
  tituloAcaoModal: any;
  mensagemConfirmacao!: string;
  _metodoPagamento = MetoPagamentoEnum;
  listaHistorico!: any[];
  hePDF: boolean = true;
  visualizarArquivoUrl: string = '';
  observation: string = '';
  pendencia: string = '';
  stepAtual!: number;
  propostaEnum = PropostaExternaEnum;
  loadingComprovante: boolean = false;
  bsConfig!: Partial<BsDatepickerConfig>;

  constructor(
    private fb: FormBuilder,
    private _geo: GeoLocalizacaoService,
    private _spinnerService: SpinnerService,
    private toastr: ToastrService,
    private _pagamentoPropostaService: PagamentopPropostaService,
    private _activeRoute: ActivatedRoute,
    private modalService: BsModalService,
    private tabService: TabNavigationService,
    private _router: Router,
    private _scrollService: ScrollService,
    private _atualizacaoForcadaService: AtualizacaoForcadaService,
    private bsLocaleService: BsLocaleService,
    private moduloPermissoesService: ModuloPermissoesService,
  ) {
    this.bsLocaleService.use('pt-br');
    this.bsConfig = {
      isAnimated: true,
      dateInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      adaptivePosition: true,
      maxDate: new Date(),
      minDate: new Date(1900, 0, 1),
      rangeInputFormat: 'DD/MM/YYYY',
    };
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.preencherDadosFormSomenteLeitura();
      this.montarListaHistoricoContratacao();
    }, 1000);
  }

  ngOnInit(): void {
    this.criarSomenteLeitura();
    this.listarTodosEstados();
    this.buscarDadosPagamentoPorProposta();
  }

  goToTop() {
    this._scrollService.scrollToElement('#propostaExterna', 140);
    this._scrollService.setStyle('#propostaExterna', {
      'margin-top': '-141px !important',
    });
  }
  async buscarDadosPagamentoPorProposta() {
    this.iniciarSpinner();
    try {
      const idProposta = this._activeRoute.snapshot.paramMap.get('idProposta');

      const dataVM: any = await lastValueFrom(
        this._pagamentoPropostaService.buscarDadosPagamentoPorProposta(idProposta),
      );
      this.listaPagamentos.push(dataVM);
      this.stepAtual = dataVM.proposalStep;

      this.observation = this.listaPagamentos[0]?.observation || '';
      this.pendencia = this.listaPagamentos[0]?.pending || '';

      this.listaPagamentos[0].creditsDate = new Date(this.listaPagamentos[0]?.creditsDate.toLocaleString('pt-BR'));

      this.listaPagamentosOriginal = JSON.parse(JSON.stringify(this.listaPagamentos));
    } catch (e: any) {
      if (!this.dadosBeneficiario[0].dadosBeneficiario?.isGeia) {
        this.stepAtual = this.dadosBeneficiario[0]?.dadosBeneficiario?.step;
        this.listaPagamentos.push({
          paymentMethod: MetoPagamentoEnum.CORRETOR_EXTERNO,
          issueDate: this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.createDate, //usado data da criacao da proposta para corretor externo
          value: this.dadosBeneficiario[0]?.dadosBeneficiario?.membershipFee,
          creditsDate: null,
          payersName: null,
          valueReceived: '0',
          observation: '',
        });
      }
      this.toastr.toastrConfig.preventDuplicates = true;
      //"Cannot read properties of null (reading 'toLocaleString')"
      if (!e.message.include("Cannot read properties of null (reading 'toLocaleString')")) {
        this.toastr.warning(e.message);
      }
      this.pararSpinner();
    } finally {
      this.pararSpinner();
    }
  }

  montarListaHistoricoContratacao(): any[] {
    this.listaHistorico = [];

    // Adiciona o titular à lista
    this.listaHistorico.push({
      produto:
        this.dadosBeneficiario &&
        this.dadosBeneficiario[0]?.dadosBeneficiario?.productTypeName + '-' + this.dadosBeneficiario &&
        this.dadosBeneficiario[0]?.dadosBeneficiario?.productName,
      nome: this.dadosBeneficiario && this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.name,
      dataNascimento: this.dadosBeneficiario && this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.birthDate,
      valor: this.dadosBeneficiario && this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.priceValue,
      titularidade: 'Titular',
    });

    // Adiciona os dependentes à lista
    this.dadosBeneficiario &&
      this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.dependentsProposal.forEach((dependente: any) => {
        this.listaHistorico.push({
          produto: this.dadosBeneficiario && this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.productName,
          nome: dependente.name,
          dataNascimento: dependente.birthDate,
          valor: dependente.priceValue,
          titularidade: 'Dependente',
        });
      });
    this.goToTop();

    return this.listaHistorico;
  }

  criarSomenteLeitura() {
    this.formTitular = this.fb.group({
      email: new UntypedFormControl(
        {
          value: null,
          disabled: true,
        },
        [],
      ),
      name: new UntypedFormControl({
        value: null,
        disabled: true,
      }),
      contrato: new UntypedFormControl({
        value: null,
        disabled: true,
      }),
      telephone: new UntypedFormControl({value: null, disabled: true}),
      cep: new UntypedFormControl({value: null, disabled: true}),
      endereco: new UntypedFormControl({value: null, disabled: true}),
      numero: new UntypedFormControl({value: null, disabled: true}),
      complemento: new UntypedFormControl({value: null, disabled: true}),
      cidade: new UntypedFormControl({value: null, disabled: true}),
      estado: new UntypedFormControl({value: null, disabled: true}),
      uf: new UntypedFormControl({value: null, disabled: true}),
    });
  }

  async preencherDadosFormSomenteLeitura() {
    this.estadoInfo = await this.retornaNomeEstado();
    const nomeCidade = await this.retornaNomeCidadePorEstado(
      this.dadosBeneficiario && this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.addressData?.stateId,
      this.dadosBeneficiario && this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.addressData?.cityId,
    );

    this.formTitular.patchValue({
      email: (this.dadosBeneficiario && this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.email) || '',
      name: (this.dadosBeneficiario && this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.name) || '',
      contrato: (this.dadosBeneficiario && this.dadosBeneficiario[0]?.dadosBeneficiario?.code) || '',
      telephone: this.dadosBeneficiario && this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.mobilePhone,
      cep:
        this.dadosBeneficiario && this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.addressData.adressCep,
      endereco:
        this.dadosBeneficiario && this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.addressData?.adress,
      numero:
        this.dadosBeneficiario &&
        this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.addressData?.adressNumber,
      complemento:
        this.dadosBeneficiario &&
        this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.addressData?.adressComplement,
      cidade: nomeCidade,
      estado: this.estadoInfo ? this.estadoInfo.name : '-',
      uf: this.estadoInfo ? this.estadoInfo.uf : '-',
    });
  }

  async retornaNomeCidadePorEstado(idEstado: string, idCidade: any): Promise<any> {
    if (idEstado) {
      this.listaCidades = await lastValueFrom(this._geo.ListCitiesByStates([idEstado]));

      const itemCidadePorEstado = this.listaCidades?.find((x: any) => x.id == idCidade);

      return itemCidadePorEstado ? itemCidadePorEstado.name : null; // Retorna null se não encontrar
    }
  }

  retornaNomeEstado(): {name: string; uf: string} | null {
    const itemLista = this.listaEstados?.find(
      (x: any) =>
        x.id == this.dadosBeneficiario &&
        this.dadosBeneficiario[0]?.dadosBeneficiario?.holderProposal?.addressData?.stateId,
    );
    return itemLista ? {name: itemLista.name, uf: itemLista.uf} : null;
  }

  contarCaracteres(event: any): void {
    this.caracteresDigitados = event.target.value.length;
  }

  teveAlteracaoNaLista(): boolean {
    return true;
  }

  validarCampos(): boolean {
    if (!this.listaPagamentos[0].creditsDate) {
      this.toastr.warning('Informe a Data do Crédito');

      return false;
    }
    if (!this.listaPagamentos[0].payersName) {
      this.toastr.warning('Informe o nome no campo (Comprovante Bancário).');

      return false;
    }
    if (!this.listaPagamentos[0].valueReceived) {
      this.toastr.warning('Informe o Valor Recebido.');

      return false;
    }
    return true;
  }

  confirmarPagamento() {
    this.iniciarSpinner();
    const propostaId = this._activeRoute.snapshot.paramMap.get('idProposta') || '';
    const contractId = this.dadosBeneficiario?.[0]?.dadosBeneficiario.contractCollectiveMembershipId || null;

    this._pagamentoPropostaService.colaboradorConfirmarPagamento(propostaId, contractId).subscribe({
      next: async (dataVM: any) => {
        try {
          this.toastr.success(dataVM.message);
          this.modalRef?.hide();
          //this.forcarAtualizacaoPropMostrarBotaoOperadora();

          if (this.teveAlteracaoNaLista()) {
            await this.salvarDadosObservable().toPromise();
          }
          this.stepAtual = this.propostaEnum.PAGAMENTO_CONFIRMADO;
          this.goToTop();
          // this.voltarAbaBeneficiario(dataVM.step);
        } catch (error) {
          this.toastr.error('Erro ao processar os dados');
        } finally {
          this.pararSpinner();
        }
      },
      error: error => {
        this.pararSpinner();
        this.toastr.error(error.message || 'Ocorreu um erro ao processar o pagamento');
      },
    });
  }

  private salvarDadosObservable() {
    const propostaId = this._activeRoute.snapshot.paramMap.get('idProposta') || '';
    const pagamento = this.listaPagamentos[0] || {};

    return this._pagamentoPropostaService.atualizarDadosPagamentoColaborador({
      proposalId: propostaId,
      creditsDate: pagamento.creditsDate || null,
      payersName: pagamento.payersName || null,
      observation: pagamento.observation || '',
      pending: pagamento.pending || '',
      valueReceived: pagamento.valueReceived || false,
    });
  }

  // private voltarAbaBeneficiario(stepAtual: number) {
  //   if (stepAtual == this.propostaEnum.PAGAMENTO_CONFIRMADO) {
  //     this.tabService.avancarParaProximaAba('pagamentoConfirmado');
  //     this.tabService.definirAbaAtivaPorNumero(stepAtual);
  //     this.tabService.definirStepAtual(stepAtual);
  //     this.forcarAtualizacaoPropMostrarBotaoOperadora();
  //   }
  // }

  forcarAtualizacaoPropMostrarBotaoOperadora() {
    this.goToTop();
    this._atualizacaoForcadaService.emitirAtualizacaoForcadaPropostaColaboradorBeneficiario();
  }

  voltar() {}

  async listarTodosEstados() {
    const data = await lastValueFrom(this._geo.ListStates());
    this.listaEstados = data;
  }

  async listarCidadesPorIdEstado(idEstado: number) {
    if (idEstado) {
      this.listaCidades = await lastValueFrom(this._geo.ListCitiesByStates([idEstado]));
    } else {
      this.listaCidades = [];
    }
  }

  abrirModalNotificar(template: TemplateRef<any>) {
    if (!this.validarCampos()) return;

    this.tituloAcaoModal = 'Notificar Pendência';
    this.modalRef = this.modalService.show(template, {
      class: 'modal-lg',
      id: 'modalNotificar',
    });
  }

  NovoAbrirModalConfirmar(template: TemplateRef<any>, origem: any) {
    this.tituloAcaoModal = 'Alerta';
    let descricaoAcao = origem == 'PAGAMENTO' ? `Confirmar o Pagamento?` : 'Notificar Pendência?';
    this.mensagemConfirmacao = `Tem certeza que deseja  ${descricaoAcao}`;
    this.modalRef = this.modalService.show(template, {
      class: 'modal-lg',
      id: origem,
    });
  }

  async confirme(acao: string) {
    try {
      if (!this.podeCadastrarEditar) {
        this.toastr.warning('Você não tem permissão para essa ação. Solicite essa permissão para seu supervisor.');
        this.toastr.toastrConfig.preventDuplicates = true;
        return;
      }
      if (!this.validarCampos()) {
        this.modalService.hide();
        return;
      }
      if (acao == 'PAGAMENTO') {
        this.confirmarPagamento();
      } else {
        if (!this.listaPagamentos[0].pending) {
          this.toastr.warning('Por favor, informe a pendência.');
          return;
        } else {
          this.iniciarSpinner();
          const resposta: any = await firstValueFrom(this.salvarDadosObservable());

          if (resposta && resposta.data) {
            this.toastr.success(resposta.data);
            this.modalService.hide();
            this.stepAtual = this.propostaEnum.PAGAMENTO_CONFIRMADO;
            this.goToTop();
          } else {
            this.toastr.warning(resposta?.mensagem || 'Não foi possível salvar os dados.');
          }
          this.pararSpinner();
        }
        this.modalService.hide();
      }
    } catch (error) {
      this.toastr.warning('Não foi possível confirmar os dados.');
    }
  }

  decline(origem?: any) {
    this.toastr.toastrConfig.preventDuplicates = true;
    this.toastr.info('Ação cancelada.');
    if (origem) this.modalService.hide(origem);
    else this.modalService.hide();
  }

  getDescricaoFormaPagamento(paymentMethod: MetoPagamentoEnum): string {
    return DescricaoMetoPagamentoEnum[paymentMethod] || '-';
  }

  getRowSpan(produto: string): number {
    // Contar quantas vezes o produto aparece na lista
    return this.listaHistorico.filter(item => item.produto === produto).length;
  }

  visulizarComprovante(visulizarComprovante: TemplateRef<any>, item?: any) {
    if (this.hePDF) {
      if (typeof item?.filePath === 'string') {
        window.open(item?.filePath, '_blank');
      }
      this.visualizarArquivoUrl = item?.filePath;
    } else {
      this.hePDF = false;
    }
  }

  updateCampo() {
    if (this.listaPagamentos.length > 0) {
      this.listaPagamentos[0].observation = this.observation;
      this.listaPagamentos[0].pending = this.pendencia;
    }
  }

  converterData(item: any) {
    this.listaPagamentos[0].creditsDate = new Date(item.toLocaleString('pt-BR'));
  }

  // recarregarRota(dados: any) {
  //   const currentUrl = this._router.url;
  //   this._router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
  //     this._router.navigate([currentUrl]);
  //     setTimeout(() => {
  //       this.voltarAbaBeneficiario(dados);
  //     }, 2000);
  //   });
  // }

  isImage(filePath: string): boolean {
    return !!filePath && /\.(jpg|jpeg|png|gif)$/i.test(filePath);
  }

  isPdf(filePath: string): boolean {
    return !!filePath && filePath.toLowerCase().endsWith('.pdf');
  }

  abirModalVisualizar() {
    this.loadingComprovante = true;
    this.iniciarSpinner();

    const comprovanteBancario = this.listaPagamentos.find((doc: any) => doc.filePath)?.filePath;

    if (comprovanteBancario) {
      this.modalVisualizarComprovanteBancarioRef = this.modalService.show(this.modalVisualizarComprovanteBancario, {
        backdrop: 'static',
        class: 'modal-lg',
        id: `modalVisualizarComprovanteBancario`,
      });

      setTimeout(() => {
        if (this.loadingComprovante) {
          this.loadingComprovante = false;
          this.pararSpinner();
        }
      }, 15000);
    } else {
      this.pararSpinner();
      this.toastr.error('Documento não encontrado.');
    }
  }

  onImageLoad() {
    this.loadingComprovante = false;
    this.pararSpinner();
  }

  onImageError() {
    this.loadingComprovante = false;
    this.pararSpinner();
    this.toastr.error('Erro ao carregar a imagem do comprovante');
  }

  onPdfLoadComplete() {
    this.loadingComprovante = false;
    this.pararSpinner();
  }

  onPdfError() {
    this.loadingComprovante = false;
    this.pararSpinner();
    this.toastr.error('Erro ao carregar o PDF do comprovante');
  }

  fecharModal() {
    this.loadingComprovante = false;
    this.pararSpinner(); // Garante que o spinner seja parado ao fechar

    if (this.modalVisualizarComprovanteBancarioRef) {
      this.modalVisualizarComprovanteBancarioRef.hide();
    } else {
      this.modalService.hide();
    }
  }

  get podeCadastrarEditar() {
    return this.moduloPermissoesService.permissaoCadastrarEditar(Modulo.CADASTROS, SubModuloNome.PROPOSTA_FINANCEIRO);
  }

  receberDeclinio(stepDeclinado: number) {
    this.stepAtual = stepDeclinado || this.propostaEnum.PROPOSTA_DECLINADA;
  }
}
